import {initElements} from "../define/shared"
import Splide from '@splidejs/splide'

export default function initTopProducts() {
    initElements(".topProducts", block => {
        const splide = block.querySelector('.splide'),
            postition = splide.dataset.position

        let args = {
            arrows: false,
            autoplay: false,
            pagination: true,
            perPage: 4,
            gap: '2.75rem',
        }

        if (postition === 'left') {
            args.height = '27rem'
            args.wheel = true
            args.direction = 'ttb'
            args.perPage = 1
            args.gap = '0'
        }

        if (postition === 'bottom') {
            args.breakpoints = {
                768: {
                    perPage: 3,
                    gap: '2rem',
                },
                600: {
                    perPage: 2,
                },
                380: {
                    perPage: 1,
                },
            }
        }


        new Splide(splide, args).mount()
    })
}
